import Swiper from 'swiper/bundle';

export const patternTimeline = () => {
  $('.timeline-swiper')
    .removeClass('wp-block-group')
    .addClass('swiper')
    .children()
    .removeClass('wp-block-group__inner-container')
    .addClass('swiper-wrapper');

  //add scrollbar
  $('.timeline-swiper').append('<div class="swiper-pagination">');

  const swiper = new Swiper('.timeline-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    slidesPerView: 2,
    centeredSlides: false,
    spaceBetween: 64,
    speed: 500,

    //progress bar
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
  });
};
